// i18n area 'backups' — locale es-MX (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da archive.es-ES.ts e sovrascrive SOLO le chiavi
// che il messicano scrive davvero in un altro modo.
// DA RIVEDERE DA MADRELINGUA: il delta è volutamente STRETTO — il corpus è
// tecnico e le due varianti coincidono quasi ovunque (nessun 'ordenador',
// nessun 'disco duro' divergente, forme di cortesia già in 'usted').
// Sidecar anti-stantie: ../meta/backups.es-MX.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './backups'

export const esMX: DeepPartial<typeof enUS> = {
  ckpt: {
    storageHint: 'Un storage dir-like (dir/NFS/CIFS/CephFS) — los artefactos son archivos normales bajo el namespace de la plataforma.',
    uploadFile: 'Subir un archivo .tvbk'
  }
}
